export default class PeopleBase 
{
    documento:string ="";
    vendorSap:string ="";
    email:string="";
    estado:boolean=true;
}